import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadComponent } from 'components/file-upload/file-upload.component';
import { ApiService } from 'services/api.service';
import { ResearchTopicByClientIdCard } from 'types/client.interface';
import { FILE_OBJECT_TYPE_RESEARCH_TOPIC, FILE_OBJECT_TYPE_RESEARCH_TOPIC_JUSTIFICATION } from 'types/file.interface';
import { BackofficeReadingRoomSubmissionCard, ReadingRoomSubmissionResearchTopicItem } from 'types/service.interface';
import { MAX_LENGTH_NAME } from 'util/form.utility';
import { RequiresRestrictedAccessModalComponent } from 'components/modal/requires-restricted-access-modal/requires-restricted-access-modal.component';
import { ToastService } from 'services/toast.service';
import { TooltipComponent } from "components/tooltip/tooltip.component";

export const VISIT_ROOM_TOPIC_ID = 'visitRoomTopicId';

@Component({
  selector: 'app-topic-info',
  standalone: true,
  imports: [
    TranslateModule,
    FileUploadComponent,
    ReactiveFormsModule,
    FormsModule,
    RequiresRestrictedAccessModalComponent,
    TooltipComponent
  ],
  templateUrl: './topic-info.component.html',
  styleUrls: ['./topic-info.component.scss', '../form/base-form.scss']
})
export class TopicInfoComponent {
  @Input() topic!: ReadingRoomSubmissionResearchTopicItem | ResearchTopicByClientIdCard;
  @Input() shouldShowhowApproveDocumentButton = false;
  @Input() showCreateNewButton = false;
  @Input() fromServiceSummary = false;
  @Input() application!: any;
  @Output() topicChanged: EventEmitter<void> = new EventEmitter<void>();
  isRequiresRestrictedAccessModalOpen = false;
  public readonly topicFileType = FILE_OBJECT_TYPE_RESEARCH_TOPIC;
  public readonly maxFieldLength = MAX_LENGTH_NAME;
  public readonly justificationFileType = FILE_OBJECT_TYPE_RESEARCH_TOPIC_JUSTIFICATION;
  constructor(
    protected router: Router,
    private apiService: ApiService,
    private toastService: ToastService
  ) {}

  addTopic(): void {
    this.router.navigate([`/petijuma-tema/pievienot/${this.application.client.id}`]);
  }

  getIsAllowedToAddFiles() {
    return ['InProcess', 'RequestedAdditionalInformation', 'SubmittedAdditionalInformation'].includes(this.application?.backofficeStatus);
  }

  getTopicFiles() {
    if ('backofficeTopicFiles' in this.topic) {
      return (this.topic as any).backofficeTopicFiles;
    } else if ('topicFiles' in this.topic) {
      return (this.topic as any).topicFiles;
    }

    return [];
  }

  getJustificationFiles() {
    if ('backofficeJustificationFiles' in this.topic) {
      return (this.topic as any).backofficeJustificationFiles;
    } else if ('justificationFiles' in this.topic) {
      return (this.topic as any).justificationFiles;
    }

    return [];
  }

  onRestrictedAccessChange(value: any): void {
    const args = {
      readingRoomSubmissionId: this.application.id,
      researchTopicId: value.id,
      restrictedAccessJustification: value.restrictedAccessJustification
    };
    this.apiService.updateSetRestrictedAccessJustificationRequest(args).subscribe(
      (app: BackofficeReadingRoomSubmissionCard) => {
        if (app) {
          this.topic = app.researchTopics?.find(
            (topic: ReadingRoomSubmissionResearchTopicItem) => topic.id === value.id
          ) as ReadingRoomSubmissionResearchTopicItem;
        }
        this.topicChanged.emit();
      },
      (error: any) => {
        console.error(error);
        this.toastService.showRequestError();
      }
    );
  }
}
